import {forms} from "./forms";
import {tables} from './tables';

function sortControls(column) {
    return (a,b, desc) => {
        if (a[column]) {
            a[column].sort();
            a = a[column][0]
        }
        if (b[column]) {
            b[column].sort();
            b = b[column][0]
        }

        if (a > b) {
            return desc ? 1 : -1;
        }
        if (b > a) {
            return desc ? -1 : 1;
        }
        return 0;
    }
}

export const assessment_type_categories = {
    "Controls Assessment": {
        forms: {
            'recommendation': [
                {
                    name: "text",
                    label: "Recommendation",
                    type: "textarea",
                },
                {
                    name: "controls",
                    label: "Controls",
                    type: "tags"
                }
            ]
        },
        tables: {
            'recommendations': [
                {
                    field: "text",
                    label: "Recommendation",
                },
                {
                    field: "controls",
                    label: "Controls",
                    attrs: {
                        width: "300px"
                    },
                    sort_func: sortControls("controls"),
                    formatter: (field) => field.join(', ')
                }
            ]
        }
    },
    "Risk Assessment": {
        forms: forms,
        tables: tables
    }
}